import React from 'react';
import {View, Text, Image, StyleSheet, ImageSourcePropType} from 'react-native';
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {ThemeType} from "@/theming/baseTheme";

interface CardProps {
    title?: string;
    image?: ImageSourcePropType;
    children?: React.ReactNode;
    style?: any;
}

export const Card: React.FC<CardProps> = ({
                                              title,
                                              image,
                                              children,
                                              style
                                          }) => {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);

    return (
        <View style={[styles.outerContainer, style]}>
            <View style={styles.container}>
                {image && (
                    <View style={styles.imageContainer}>
                        <Image
                            source={image}
                            style={styles.image}
                            resizeMode="cover"
                        />
                    </View>
                )}

                <View style={styles.content}>
                    {title && (
                        <Text style={styles.title}>{title}</Text>
                    )}

                    {children && (
                        <View style={styles.childrenContainer}>
                            {children}
                        </View>
                    )}
                </View>
            </View>
        </View>

    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    outerContainer: {
        flexDirection: "row",
    },
    container: {
        flex: 1,
        backgroundColor: theme.colors.surface,
        borderRadius: theme.borderRadius.md,
        shadowColor: theme.colors.shadow,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 3, // Android shadow
        overflow: 'hidden',
    },
    imageContainer: {
        width: '100%',
        height: 200,
        overflow: 'hidden',
        borderTopLeftRadius: theme.borderRadius.md,
        borderTopRightRadius: theme.borderRadius.md,
    },
    image: {
        width: '100%',
        height: '100%',
    },
    content: {
        padding: theme.spacing.md,
    },
    title: {
        fontSize: theme.fontSize.lg,
        fontWeight: '600',
        color: theme.colors.text,
        marginBottom: theme.spacing.sm,
    },
    childrenContainer: {
        // Container for children content
    },
});
